
































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { performanceServer, siteManagementServer } from '@/api/installServer';
import dayjs from 'dayjs';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
})
export default class BlastingTicketDetails extends Vue {
  // 父组件传递过来的控制编辑页面: 1：主页面 2：编辑页面 3：新增下级页面 4：新增页面
  @PropSync('showFlag', Number) showWhatFlag!: number;
  @Prop(Object) row!: Record<string, any>; // 父组件传递过来的需要修改一行的数据
  scrollbar = false;
  validatorCodeUrl = ''; // 签名图片路径

  newDataForm: any = {};
  private URLPath: any = '';
  // 表单数据
  private formData: any = {
    applyId: '',
    applyStaffId: '',
    applyStaffName: '',
    approvalFlowExampleId: '',
    controlsRecord: [],
    finishFlag: false,
    finishTime: '',
    id: '',
    processLog: [
      {
        actionList: [],
        afterFlowNode: '',
        afterFlowNodeName: '',
        beforeFlowNode: '',
        beforeFlowNodeName: '',
        endTime: '',
        flowExampleId: '',
        id: '',
        memberList: [
          {
            objId: '',
            objName: '',
            type: '',
          },
        ],
        operation: '',
        operationName: '',
        startTime: '',
        withdraw: false,
      },
    ],
    safetyMeasureRecord: [],
    taskEndTime: '',
    taskStartTime: '',
    taskUnit: '',
    type: '',
    workOrder: '',
  };
  imgPath: any = 'data:image/jpeg;base64,';

  created() {
    this.URLPath = publishObjectPath.imgPathWater;
    this.getData(this.row);
  }

  mounted() {
    // this.hasScrollbar();
  }

  // hasScrollbar() {
  //   const dom: any = document.getElementById('main_box');
  //   this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  // }

  getData(data: any) {
    // 通过主键查询单条数据
    siteManagementServer
      .getSingleSiteManagementData(data.id)
      .then((res: any) => {
        this.formData = res.data;
        // 中部动态内容处理--开始
        res.data.processLog.splice(0, 1);

        if (res.data.controlsRecord && res.data.controlsRecord.length > 0) {
          res.data.controlsRecord.map((item: any, index: any) => {
            if (this.isJson(item.value)) {
              item.value = JSON.parse(item.value).info ? JSON.parse(item.value).info : JSON.parse(item.value).name;
            }
            if (item.value.indexOf('"') !== -1) {
              item.value = JSON.parse(item.value);
            }
            if (item.value.constructor === Object) {
              item.value = item.value.info ? item.value.info : item.value.name;
            }
            if (item.value instanceof Array && item.title.indexOf('图片') === -1) {
              const newArr: any = [];
              item.value.map((itemInner: any) => {
                newArr.push(itemInner.name + '：' + itemInner.value);
              });
              item.value = newArr.join(', ');
            }
            if (item.title.indexOf('图片') !== -1) {
              this.newDataForm.title = item.title;
              this.newDataForm.img = item.value;
              res.data.controlsRecord.splice(index, 1);
            }
          });
        }

        res.data.processLog.map((r: any, index1: any) => {
          r.actionList.forEach(async (i: any) => {
            const resInner: any = await this.getSignatureData(i.signature);
            i.deptName = resInner && resInner.deptName ? resInner.deptName : '';
            i.postNames = resInner && resInner.postNames ? resInner.postNames : '';
            i.signature = resInner && resInner.signature ? resInner.signature : '';
          });
        });
        this.formData = res.data;
        // 中部动态内容处理--结束
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  getValidatorCode(id: any): void {
    performanceServer
      .getValidatorCode(id)
      .then((res: any) => {
        // console.log(res);
        // this.validatorCodeUrl = 'data:image/jpeg;base64,' + res.data.signature;
      })
      .catch((error: any) => {
        this.$message.error('获取签名图片失败，请重试！');
      });
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  async getValidatorInnerCode(id: any) {
    const res: any = await performanceServer.getValidatorCode(id);
    return res.data.signature;
  }

  timeBlastingProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return SY + '年' + SM + '月' + SD + '日';
  }

  timeProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return SY + '年' + SM + '月' + SD + '日' + Sh + '时' + Sm + '分';
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.newDataForm = {};
    this.validatorCodeUrl = '';
    this.showWhatFlag = 1;
  }
  // 判断是否为json格式
  isJson(data: any) {
    if (typeof data === 'string') {
      try {
        const obj: any = JSON.parse(data);
        if (typeof obj === 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }

  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.URLPath}${item.path}`);
    });
    return arr;
  }
}
